
// import all css and other components
import "./css/Home.css";
import axios from "axios";
import { connect } from "react-redux";
import React from "react";
import reqwest from "reqwest";
import {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateUid,
  activateDatadicbackup,
  activateFiname,
  activateScreen,
  activateSaveFilter,
  activatePageswitch,
  activateChange,
} from "./redux";
import Fselectf from "./components/Fselectf";
import { Layout, Button, Modal, Select, Row, Col, Space,Collapse ,PageHeader, Descriptions,Tag,Table,List,Popconfirm ,Menu,Dropdown } from "antd";
import Selection from "./components/Selection";
import DropDwnTr from "./components/DropdownTr";
import Dropdowns from "./components/Dropdowns";
import Sliderlo from "./components/Sliderlo";
import Sliderbub from "./components/Sliderbub";
import TableAPP from "./components/Table";
import SaveFilter from "./components/SaveFilter";
import ScreenMenu from "./components/ScreenMenu"; 
import { Link } from 'react-router-dom'
import {
  UserOutlined,PlayCircleTwoTone
} from '@ant-design/icons';
//
import {
  CloseCircleTwoTone,
  PoweroffOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
  FolderOpenOutlined ,
  RedoOutlined,
  SaveOutlined 

} from "@ant-design/icons";
const { Panel } = Collapse;
const { Header, Content } = Layout;



function showfilters(a) {
  var ab=JSON.parse(a);
  if (ab!= undefined) {
    console.log('----------------',ab)
      var gc=[]
      ab.columns.map((experience, i) => {
     if ( experience.selectedUI==1){
       gc[i]=<Tag>{experience.colEnName} </Tag>; 
     }

    })
    return gc;  
    }
}


class Homeclass extends React.Component {
  constructor(props) {
  
    super(props);
    this.props.activatePath(this.props.paths);
    this.props.activateUid(this.props.uids);
    this.state = {
      isModalVisible: false,
      setIsModalVisible: false,
      lookingTickers: false,
      apppath: this.props.paths,
      uid: this.props.uids,
      requestFailed: false,
    };
    this.HandleReq = this.HandleReq.bind(this);
    this.HandleReqcount = this.HandleReqcount.bind(this);
    this.removeManage = this.removeManage.bind(this);
    this.handle = this.handle.bind(this);
    this.handledel = this.handledel.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    
  }
  FilterMount() {
    this.setState({ loading: true });
    reqwest({
      url:
        this.props.apppath + "/include/api/screener/stockScreenerFilter.json",
      //url:'jlast.json',
      method: "get",
      type: "json",
    }).then((data) => {
      this.props.activateDatadic({ FilterDic: data.tables[0] });
      
      this.setState({
        data: data.tables[0].columns,
      });
    });
  }
  HandleReq() {
    this.props.activateScreen(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic] }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
         
          },
          () => {
            this.props.activateRecord(data.filteredData.length);
            this.props.activateStocks(data.filteredData )
            this.props.activateScreen(false);
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     
        this.props.activateScreen(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
  }

  handledel(id) {
  
    this.setState({
      loading: true,
    });
    const del = { filterid: id, userId: this.props.uids };
    axios
      .post(this.props.apppath + "/include/api/screener/Simdel.cfm", del)
      .then((response) => this.handle());
  }
  handle() {
    this.setState({
      loading: true,
    });
    reqwest({
      url:
        this.props.apppath +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.uids,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
        savefill: false,
      });
    });
  }

  componentDidMount() {
    this.props.activateChange('');
    
    this.setState({
      loading: true,
    });
    reqwest({
      url:
      this.props.paths +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.uids,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
      });
    });


  }

  HandleReqcount() {
    this.props.activateScreen(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic] }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data,
         
          },
          () => {
            this.props.activateRecord(data);
            this.props.activateScreen(false);
          
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     
        this.props.activateScreen(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
  }

  removeManage(){
    this.setState({
      loading: true,
    });
   // this.FilterMount();
    reqwest({
      url:
      this.props.paths +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.uids,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
      });
      
     // this.props.activatePageswitch(data.results);
      this.props.activateSaveFilter(data.results); 
    });
    if (this.props.finame=='Untitled New Screen'){
    this.props.activateFiname('Untitled New Screen');
    }else {
      this.props.activateFiname(this.props.pageswitch);
    }
    
  }
  handleMenuClick(e) {
    window.location.href = this.props.paths+'/login/completelogout';
  }
  render() {
    const columns = [
      {
        title: 'Screen Name',
        dataIndex: 'NAME_',
        key: 'name',
        width:'18%',
        render: text => <span>{text}</span>,
      },
      {
        title: 'Description',
        dataIndex: 'description_',
        key: 'description_',
        width:'20%',
        render: text => <span>{text}</span>,
      },
      
      {
        title: 'Filters',
        key: 'FILTER_',
        dataIndex: 'FILTER_',
        width:'50%',
        render: FILTER_ => (
          <>
            {showfilters(FILTER_)}
          </>
        ),
      },

      {
        title: 'Action',
        key: 'id',
        dataIndex: 'id',
        render: (text, record) => (
      
          <div   onClick={(e) => { this.handledel(text) }} >  <Button type="primary" danger>
          Delete
        </Button>  </div> 
       
     ),
      },
      
    ]; 


    const data = [
      {
        key: '1',
        name: 'John Brown',
        age: 32,
        address: 'New York No. 1 Lake Park',
        tags: ['nice', 'developer'],
      },
      {
        key: '2',
        name: 'Jim Green',
        age: 42,
        address: 'London No. 1 Lake Park',
        tags: ['loser'],
      },
      {
        key: '3',
        name: 'Joe Black',
        age: 32,
        address: 'Sidney No. 1 Lake Park',
        tags: ['cool', 'teacher'],
      },
    ];


    const { loadings } = this.state;
    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
        loadings: [],
      });
    };
    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };
    var compo = [];
    var coltype = '';
    if (this.props.datadic.FilterDic != undefined) {
      console.log( this.props.datadic.FilterDic.columns)
      this.props.datadic.FilterDic.columns.map((experience, i) => {
        if (experience.type == "slider" && experience.selectedUI == 1) {
       
          if (experience.typeCol.toLowerCase() =='percentile'){
            coltype='percentile';
             console.log('percentile')
           }
           if (experience.typeCol.toLowerCase() =='absolute'){
            coltype='absolute';
            console.log('absolute')
       
           }
           console.log('VVVVVVVVVVV',coltype)
          compo[i] = <Sliderlo filtermt={compo.length} id={i} pass={experience} coltype={coltype} colNameId={experience.colNameId}></Sliderlo>;
        }
        if (experience.type == "sliderPrice" && experience.selectedUI == 1) {
          compo[i] = <Selection filtermt={compo.length} id={i} pass={experience}></Selection>;
        }
        if (
          experience.type == "dropdownTr" &&
          experience.selectedUI == 1 &&
          experience.label != "Industry"
        ) {
          compo[i] = <DropDwnTr filtermt={compo.length} id={i} pass={experience}></DropDwnTr>;
        }
        if (experience.type == "bubbleSlider" && experience.selectedUI == 1) {
          compo[i] = <Sliderbub filtermt={compo.length} id={i} pass={experience}></Sliderbub>;
        }
        
        if (experience.type == "dropdown" && experience.selectedUI == 1) {
          compo[i] = <Dropdowns filtermt={compo.length} id={i} pass={experience}></Dropdowns>;
        }

        
      });
      
    }
 
    const gridStyle = {
      width: "100%",
    };

    const ButtonStyle = {
      width: "100px",
      marginLeft: "20%",
      marginTop: "2%",
    };

    const resultsStyle = {
      width: "100px",
      fontWeight: "800",
    };
    const resultfontsStyle = {
      width: "100%",
      fontWeight: "800",
      fontSize: "22px",
    };
 
    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="1">Log Out</Menu.Item>
      
      </Menu>
    );
    return (
      <div className="Home">
      
        <Layout className="layout">
          
    <div className="headerclass">
         <div className="logo">
                
                 <img src={ 'https://www.aaii.com/images/lp/aaiilogo.png'} />  
            
        </div>

        <div  className="logoLogin" >


        <a href={'https://youtu.be/fdzFFDLy86k'}  target="_blank">
     <Button type="primary" icon={<PlayCircleTwoTone  />}>
      Intro Video
    </Button>
    </a>
    {' ' }

        <a href={this.props.paths+'/contact/webdeptsimpless'}>
     < Button   className="bcolo"  ghost    >
     Stock Screener Feedback 
    </ Button>
      </a>
      {' ' }
        <Dropdown.Button overlay={menu} className="bcolo"    ghost icon={<UserOutlined  />}>
        <span style={{textTransform: 'capitalize'}}>  Welcome, {this.props.uname} </span>
    </Dropdown.Button>
    
    </div>



    </div>
    <div className="backaaii" ><Link onClick={this.removeManage} to="/"> Back to Screen Builder</Link> </div>
    <div className="ssslogo"> <img src={ 'https://www.aaii.com/images/lp/sss.png'} /> <span className="logotext">AAII Stock Screener  </span>
    <span className="beta">BETA</span>  </div>
  
  <div className='screenMen' >
    <div className='screennames'><ScreenMenu  showModal={showModal}></ScreenMenu></div>
  

   </div>
          <Content>
         <div>
         <div  >
         <Table columns={columns} dataSource={ this.state.data} style={{width:'80%',marginLeft:'5%'}}  pagination={false} loading={this.state.loading} />
              </div>
            </div> 
          </Content>
          <br></br><br></br><br></br><br></br>
        </Layout>
      {/*   <Link to="/tbs">with hash</Link>  */}
         
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  uid: state.auid,
  finame: state.finame,
  screen: state.screen,
  datadicbackup: state.datadicbackup,
  savefilter: state.savefilter,
  pageswitch: state.pageswitch,
 
});

const mapDispatchToProps = {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateUid,
  activateDatadicbackup,
  activateFiname,
  activateScreen,
  activateSaveFilter,
  activatePageswitch,
  activateChange,
  activateChange,
};

const Home = connect(mapStateToProps, mapDispatchToProps)(Homeclass);

export default Home;
